import React from 'react';
import { Navigate } from 'react-router-dom';
import { isSuperAdminAuthenticated } from '../services/superAdminAuthService';

/**
 * Protected route component for super admin pages
 * Redirects to login if not authenticated
 * @param {Object} props Component props
 * @param {JSX.Element} props.children Child components to render if authenticated
 * @returns {JSX.Element} Protected route
 */
const ProtectedSuperAdminRoute = ({ children }) => {
  return isSuperAdminAuthenticated() ? children : <Navigate to="/superadmin/login" replace />;
};

export default ProtectedSuperAdminRoute;

